module.exports = __webpack_public_path__ + "img/D201807_4.ba20b9ed.jpg";